import { ROUTES } from "~/constants/routing";
import type { IEmbedConfig } from "~/feature/embed/types";
import { buildEmbedSearch } from "~/feature/embed/utils/embedParams";
import { getSiteOrigin } from "~/utils/getSiteOrigin";

export const getEmbedUrl = (
  config: IEmbedConfig,
  origin: string = getSiteOrigin()
): string =>
  `${origin}${ROUTES.embed.createURL(buildEmbedSearch(config).toString())}`;
